import * as devisConf from '@/configuration/devisConf';

export default function selectLinesFormRegroupementPersonalise(lignesCommande) {
  const referencesPersoSelectionnee = lignesCommande
    .filter(ligne => {
      return ligne.selected && ligne.referencePersonnalise
        && ligne.type === devisConf.PERSONNALISE;
    }).map(perso => {
      return perso.referencePersonnalise;
    });
  return lignesCommande.filter(ligne => {
    return ligne.selected || referencesPersoSelectionnee.includes(ligne.referencePersonnalise);
  });
}
